import { useQuery } from '@tanstack/react-query';
// Service
import { getAllContentTranslationsDataVersion } from './contentTranslationService';

/**
 * @description useQuery Hook to get all data versions from a content translation ID.
 * @param {string} contentTranslationId
 * @param {object} queryParams
 * @param {number} queryParams.pageNumber
 * @param {number} queryParams.pageSize
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * {data: ContentTranslationDataVersion[], pagination: Pagination}, Error>}
 */
export const useGetAllContentTranslationsDataVersionQuery = (
  contentTranslationId,
  queryParams,
  options,
) => useQuery({
  queryKey: ['contentTranslation-data-version', contentTranslationId, queryParams],
  queryFn: () => getAllContentTranslationsDataVersion(contentTranslationId, queryParams),
  ...options,
});
